import React, {useEffect} from 'react';
import '../css/Information.css';
import Information from "../components/Information";
import {contactDetails} from "../config/stockEyesConfig";

function AboutPage() {

    // set document title
    useEffect(() => {
        document.title = "About us";
    }, []);

    return (
        <Information title={"About us"}>
            <h1>Welcome to StocksEyes</h1>
            <p>At Stockseyes.com, we specialize in providing APIs to access real-time and historical stock data. Our services are tailored for developers, fintech companies, and businesses that require fast, reliable access to stock market information.</p>
            <p>We do not provide any stock analysis, investment tips, or financial advice. Our sole focus is to deliver accurate and up-to-date market data through easy-to-use APIs.</p>
            <p>Our APIs are built to support a wide range of use cases including stock screeners, trading platforms, and personal finance apps. Whether you're building a mobile app or a web platform, our APIs offer the data infrastructure you need.</p>
            <p>In addition to real-time data, we also offer access to historical stock data to help you build features like price charts, backtesting tools, and market research applications.</p>
            <p>If you're interested in custom data solutions such as tailored API endpoints or daily data downloads in Excel format, feel free to reach out to us by emailing at {contactDetails.email} or by calling us on {contactDetails.phone}.</p>
            <p>Thank you for choosing Stockseyes as your trusted source for stock data APIs.</p>
        </Information>
    );
}

export default AboutPage;
